import { createWebHistory, createRouter } from "vue-router";
import ClientApp from '../components/ClientApp'
import AdminApp from '../components/AdminApp'
import Login from '../components/Login'
import Request from '../components/Request'
import Reset from '../components/Reset'
import NotFound from '../components/NotFound'
import Requests from '../components/Admin/Requests'
import Customers from '../components/Admin/Customers'
import LXTerminals from '../components/Admin/LXTerminals'
import Settings from '../components/Admin/Settings'
import ManageEventStatus from '../components/ManageEventStatus'



const routes = [
    {
        path: "/",
        name: "ClientApp",
        component: ClientApp,
    },
    {
        path: "/manage/",
        name: "AdminApp",
        component: AdminApp,
        children: [
            {
                name: "Requests",
                path: "",
                component: Requests
            },
            {
                name: "Requests",
                path: "requests",
                component: Requests
            },
            {
                name: "Customers",
                path: "customers",
                component: Customers
            },
            {
                name: "LX-Terminals",
                path: "lx-terminals",
                component: LXTerminals
            },
            {
                name: "Settings",
                path: "settings",
                component: Settings
            },
        ]
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
    },
    {
        path: "/request",
        name: "Request",
        component: Request,
    },
    {
        path: "/reset-password",
        name: "Reset",
        component: Reset,
    },
    {
        path: "/event-status",
        name: "ManageEventStatus",
        component: ManageEventStatus,
    },
    {
        path: '/:pathMatch(.*)*',
        name: "NotFound",
        component: NotFound
    },
];

const router = createRouter({
    linkActiveClass: "active",
    history: createWebHistory(),
    routes,
});

export default router;
